import React from "react";
import "antd/dist/antd.css";
import "./BasicLayout.css";
import {Button, Layout, Result} from "antd";
import {BrowserRouter, Link, Route, Switch} from "react-router-dom";
import Page from "../../core/router/Page";
import Login from "../../pages/Login/Login";
import BasicLayoutContainer from "./BasicLayout.style";
import NavBar from "../NavBar/NavBar";
import SideBar from "../SideMenu/SideMenu";
import ErrorNotFound from "../../pages/ErrorPages/ErrorNotFound";

const {Content, Footer} = Layout;

function ForbiddenComponent() {
    return <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={<Button type="primary">
            <Link to={'/'}>Back to Home</Link>
        </Button>}
    />;
}

const BasicLayout = props => {

    const showAvailableRoutes = () => {
        const {menuItems, pages, customItems} = props;
        const store = {};
        let firstItemKey = null;
        let firstItem = true;
        menuItems.forEach(el => {
            if (el.subItems && el.subItems.length > 0)
                el.subItems.forEach(sub => {
                    if (firstItem) {
                        firstItem = false;
                        firstItemKey = sub.key;
                    }
                    store[sub.key] = sub.rules || {};
                });
            else {
                if (firstItem) {
                    firstItem = false;
                    firstItemKey = el.key;
                }
                store[el.key] = el.rules || {};
            }
        });
        customItems.forEach(el => {
            store[el.key] = el.rules || {};
        });
        return pages.map(el => {
            const path = [`/${el.key}${el.hasParam ? "/:param" : ""}`];
            if (firstItemKey === el.key) {
                path.push("/");
            }

            return (
                <Page
                    key={el.key}
                    exact
                    component={el.component}
                    path={path}
                    id={el.key}
                    store={store}
                    redirectUrl={`/403`}
                    {...el.componentProps}
                />
            );
        });
    };

    const authenticated = props.authenticated || false;
    if (!authenticated)
        return <Login loginLogoStyle={props.loginLogoStyle}/>;
    const {
        logo,
        dropdownItems,
        applicationName,

        menuItems,
        user,
        userData,
        footerStyle,
        footer,
        notFound,
        forbidden,
        theme,
        darkMode,
        primaryColor,
        isExtraSmall
    } = props;

    const forbiddenPage = forbidden || ForbiddenComponent;
    return (
        <BrowserRouter>
            <BasicLayoutContainer darkMode={darkMode} isExtraSmall={isExtraSmall}>
                <NavBar className={'navbar-container'}
                    user={user} userData={userData} menuItems={menuItems} dropdownItems={dropdownItems} applicationName={applicationName}theme={theme} darkMode={darkMode} primaryColor={primaryColor}>
                    {props.headerComponents}
                </NavBar>
                <Layout className={'app-content'}>
                    <SideBar menuItems={menuItems} theme={theme} primaryColor={primaryColor}/>
                    <Content>
                        <Switch>
                            <Route path="/403" exact component={forbiddenPage}/>
                            <Route path="/404" exact component={ErrorNotFound}/>
                            {showAvailableRoutes()}
                            <Route component={ErrorNotFound}/>
                        </Switch>
                    </Content>
                    {footer && <Footer style={footerStyle || {textAlign: "center"}}>
                        {footer}
                    </Footer>
                    }
                </Layout>
            </BasicLayoutContainer>
        </BrowserRouter>
    );
}

export default BasicLayout;
